import { PropsWithChildren, ReactNode } from 'react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

interface ItemProps extends PropsWithChildren {
  title: string;
  hideTitle?: boolean;
  icon?: ReactNode;
  suffix?: ReactNode;
}

function Item({ title, hideTitle, icon, suffix, children }: ItemProps) {
  return (
    <div className={css.item}>
      {icon && (
        <span className={css.icon} aria-hidden>
          {icon}
        </span>
      )}
      <dt className={cn(css.title, hideTitle && 'sr-only')}>{title}</dt>
      <dd className={css.value}>{children}</dd>
      {suffix && <span className={css.suffix}>{suffix}</span>}
    </div>
  );
}

interface RootProps extends PropsWithChildren {
  className?: string;
  direction?: 'row' | 'column';
}

function Root({ children, className, direction = 'row' }: RootProps) {
  return (
    <dl className={cn(css.root, className)} data-direction={direction}>
      {children}
    </dl>
  );
}

export const PropertyList = Object.assign(Root, {
  Item,
});
